import React, { Component, createRef } from 'react';
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import './Careers.js'
import { BASEURL } from '../conf';

import swal from 'sweetalert';


export class JobDescription extends Component {
  // constructor(props) {
  //     super(props);
  //     this.state = {
  //         isPopupVisible: false, // State to control popup visibility
  //         job: {}, // Placeholder for job data
  //     };
  //     // Create a ref for the file input element
  //     // this.fileInputRef = React.createRef();
  //     this.detailsRef = createRef();
  //     this.fileInputRef = React.createRef();
  //     // Bind methods
  //     this.handleButtonClick = this.handleButtonClick.bind(this);
  //     this.handleFileChange = this.handleFileChange.bind(this);
  //     this.handleSubmitResume = this.handleSubmitResume.bind(this);
  // }


  constructor(props) {
    super(props);
    this.state = {
      isPopupVisible: false,
      job: {},

      // Resume upload
      selectedFile: null,
      selectedFileName: "",

      // ----- Form Fields -----
     name: "",
  phone: "",
  email: "",
  currentCTC: "",
  expectedCTC: "",
  noticePeriod: "",
  errors: {}

    
    };

    // Refs
    this.detailsRef = createRef();
    this.fileInputRef = React.createRef();

    // Bind methods
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmitResume = this.handleSubmitResume.bind(this);
  }




  togglePopup = () => {
    this.setState((prevState) => ({ isPopupVisible: !prevState.isPopupVisible }));
  };

  redirectToEmail = () => {
    // console.log('mail toooo')
    const recipientEmail = 'hello@simply.science';
    const subject = 'Resume Submission';
    const body = 'Hello, \n\nPlease find my resume attached.';

    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  handleButtonClick() {
    // Trigger the file input click
    this.fileInputRef.current.click();
  }

  handleFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      const UPLOAD_RESUME_SIZE_LIMIT = 2 * 1024 * 1024; // 2MB in bytes
      const allowedFileTypes = ['application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (file.size > UPLOAD_RESUME_SIZE_LIMIT) {
        swal('Error', 'File size exceeds 2MB limit.', 'error');
        return;
      }

      if (!allowedFileTypes.includes(file.type)) {
        swal('Error', 'Invalid file type. Only PDF, DOC, and DOCX files are allowed.', 'error');
        return;
      }

      // Update the state with the selected file
      this.setState({
        selectedFile: file,
        selectedFileName: file.name
      });
    }
  }
  componentDidMount() {
    // Assuming 'job' is passed via props
    const job = this.props.location?.state || {};
    this.setState({ job });
  }




validateField = (name, value) => {
  let error = "";

  switch (name) {
    case "name":
      if (!/^[A-Za-z ]*$/.test(value)) {
        error = "Name should contain only alphabets";
      } else if (value.length > 30) {
        error = "Name should not exceed 30 characters";
      }
      break;

    case "phone":
      if (!/^[0-9]*$/.test(value)) {
        error = "Phone number should contain only numbers";
      } else if (value.length !== 10) {
        error = "Phone number must be 10 digits";
      } else if (!/^[6-9]/.test(value)) {
        error = "Enter a valid Indian phone number";
      }
      break;

    case "email":
      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ) {
        error = "Enter a valid professional email address";
      }
      break;

    case "currentCTC":
    case "expectedCTC":
      if (!/^[0-9]*$/.test(value)) {
        error = "CTC should contain only numbers";
      } else if (value.length > 7) {
        error = "CTC should not exceed 7 digits";
      }
      break;

    default:
      break;
  }

  this.setState((prev) => ({
    errors: { ...prev.errors, [name]: error }
  }));
};







  validateForm = () => {
    const {
      name, phone, email, currentCTC, expectedCTC, noticePeriod
    } = this.state;

    // Required fields
    if (!name || !phone || !email ) {
      swal("Error", "Please fill all required fields.", "error");
      return false;
    }

    // Name Validation – alphabets + spaces only (max 30 chars)
    const nameRegex = /^[A-Za-z ]{1,30}$/;
    if (!nameRegex.test(name)) {
      swal("Error", "Name should contain only letters and spaces (max 30 characters).", "error");
      return false;
    }

    //  Phone Validation – Indian 10-digit number starting with 6,7,8,9
    const phoneRegex = /^[6-9][0-9]{9}$/;
    if (!phoneRegex.test(phone)) {
      swal("Error", "Enter a valid 10-digit  phone number.", "error");
      return false;
    }

    //  Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      swal("Error", "Please enter a valid email address.", "error");
      return false;
    }


    // Notice Period must be selected
    if (!noticePeriod || noticePeriod.trim() === "") {
      swal("Error", "Please select a Notice Period.", "error");
      return false;
    }


    //  Numeric validations (CTC + Experience)
    const numberFields = [
      { field: currentCTC, name: "Current CTC" },
      { field: expectedCTC, name: "Expected CTC" },
    ];

    for (let item of numberFields) {
      if (item.field && isNaN(item.field)) {
        swal("Error", `${item.name} must be a valid number.`, "error");
        return false;
      }

      if (item.field && item.field.length > 7) {
        swal("Error", `${item.name} cannot exceed 7 digits.`, "error");
        return false;
      }
    }

    return true; // All validations passed
  };


  handleSubmitResume = async () => {
    const { job, selectedFile } = this.state;

    if (!this.validateForm()) {
      return; // Stop if validation fails
    }

    if (!selectedFile) {
      swal("Error", "Please select a resume before submitting.", "error");
      return;
    }
    if (selectedFile) {
      // console.log('this.state.job.role', this.state.job.role)
      // console.log('selectedFile', selectedFile)
      swal({
        text: 'Please wait submitting the resume',
        button: {
          visible: false
        },
        closeOnClickOutside: false,
        closeOnEsc: false
      })
      const formData = new FormData();
      formData.append('resume', selectedFile);
      formData.append('jobRole', this.state.job.role);
      formData.append("name", this.state.name);
      formData.append("phone", this.state.phone);
      formData.append("email", this.state.email);
      formData.append("currentCTC", this.state.currentCTC);
      formData.append("expectedCTC", this.state.expectedCTC);
      formData.append("noticePeriod", this.state.noticePeriod);
   
      // console.log('formData', formData)
      try {
        const response = await fetch(`/resume`, {
        //  const response = await fetch(`${BASEURL}/resume`, {

          method: "POST",
          body: formData,
        });

        //   console.log("Raw Response:", response);

        if (!response.ok) {
          // console.log(" RESPONSE FAILED:", response.status, response.statusText);
          const errorText = await response.text();
          // console.log(" SERVER ERROR BODY:", errorText);
          swal("Error", "Server Error While Submitting Resume", "error");
          return;
        }

        const result = await response.json();
        //   console.log("Parsed JSON:", result);

        if (result.success) {
          swal("Success", "Your Details uploaded successfully!", "success").then(() => {
            this.setState({ isPopupVisible: false });
          });
        } else {
          swal("Error", result.message || "Error in submitting the Resume", "error");
        }

      } catch (error) {
        //   console.error(" FETCH FAILED:", error);
        swal("Error", "Error in submitting the Resume", "error");
      }

    }
  }


  render() {
    const job = this.props.location.state; // Access the 'job' object
    // console.log('job', job)
    const { isPopupVisible } = this.state;
    const { HyderabadJobs, selected_job, selectedFileName } = this.state;


    return (
      <div>
        <Navbar page="careers" />
        <div className='job_container'>

          <div className='job_heading_sec'>

            <h4>{job.role}</h4>
            <div className='job-roles'>
              <div className='job-header'>
                <div className='jobtype'>
                  <img src={job.typeImage} alt="Job Type" className='jobImage' />
                  {job.type}
                </div>
                <div className='joblocation'>
                  <img
                    src={job.locationImage}
                    alt="Location"
                    className='locationImages'
                  />
                  {job.location}
                </div>
              </div>

              <div className="apply_now">
                <button className="upload_btn" onClick={this.togglePopup}>
                  Apply Now
                </button>
              </div>
            </div>
          </div>

          <div className='job_body_sec'>
            {
              job.industry &&
              <div>
                <div className='skill_heading'>Industry:</div>

                <ul>
                  <li className='skill_item'>{job.industry}</li>
                </ul>
              </div>
            }
            {
              job.companyprofile &&
              <div>
                <div className='skill_heading'>Company Profile:</div>

                <ul>
                  <li className='skill_item'>{job.companyprofile}</li>
                </ul>
              </div>
            }
            {
              job.jobdesc &&
              <div>
                <div className='skill_heading'>Job Description:</div>

                <ul>
                  <li className='skill_item'>{job.jobdesc}</li>
                </ul>
              </div>
            }
            
            {job.skills &&
              <div>
                <div className='skill_heading'>Required Skill Set:</div>
                <ul>
                  {
                    job.skills.map((item, index) => {
                      return (
                        <li key={index} className='skill_item'>{item.point}</li>
                      )
                    })
                  }
                </ul>
              </div>
            }
            {job.responsibilities &&
              <div>
                <div className='skill_heading'>Responsibilities:</div>
                <ul>
                  {
                    job.responsibilities.map((item, index) => {
                      return (
                        <li key={index} className='skill_item'>{item.point}</li>
                      )
                    })
                  }
                </ul>
              </div>
            }
            {job.preferable &&
              <div>
                <div className='skill_heading'>Preferable:</div>
                <ul>
                  {
                    job.preferable.map((item, index) => {
                      return (
                        <li key={index} className='skill_item'>{item.point}</li>
                      )
                    })
                  }
                </ul>
              </div>
            }
            {job.desiredprofile &&
              <div>
                <div className='skill_heading'>Desired profile of the candidate:</div>
                <ul>
                  {
                    job.desiredprofile.map((item, index) => {
                      return (
                        <li key={index} className='skill_item'>{item.point}</li>
                      )
                    })
                  }
                </ul>
              </div>
            }
            {
              job.relevantindustry &&
              <div>
                <div className='skill_heading'>Relevant Industry:</div>
                <ul>
                  <li className='skill_item'>{job.relevantindustry}</li>
                </ul>
              </div>
            }

            {
              job.experience && <div>
                <div className='skill_heading'>Experience Level:</div>
                <ul>
                  <li className='skill_item'>{job.experience}</li>
                </ul>
              </div>
            }
            {
              job.compensation && <div>
                <div className='skill_heading'>Compensation:</div>
                <ul>
                  <li className='skill_item'>{job.compensation}</li>
                </ul>
              </div>
            }

            {
              job.joining && <div>
                <div className='skill_heading'>Joining:</div>
                <ul>
                  <li className='skill_item'>{job.joining}</li>
                </ul>
              </div>
            }

            {
              job.interviewprocess && <div>
                <div className='skill_heading'>Interview Process:</div>
                <ul>
                  <li className='skill_item'>{job.interviewprocess}</li>
                </ul>
              </div>
            }

            {
              job.contact && <div>
                <div className='skill_heading'>Contact Information :</div>
                <ul>
                  <li className='skill_item'>{job.contact}</li>
                </ul>
              </div>
            }




          </div>


        </div>
        {/* {isPopupVisible && (
                    <div className="popup-overlay">
                        <div className="popup-content">
                            <div className='popup-header'>
                                <h3>Select Your Resume</h3>
                                <button
                                    className="close-button"
                                    onClick={() => this.setState({ isPopupVisible: false })} 
                                >
                                    <img src="/assets/Vector.png" width={"30%"} alt="homescreen" />
                                </button>
                            </div>
                            <div className="upload-container">
                                <div className='btn_hint'>
                                    <button className="upload-button" onClick={this.handleButtonClick}>
                                        Choose file
                                    </button>
                                    <span className="file-hint">(as .pdf, .doc, or .docx file)</span>
                                </div>
                                <input
                                    type="file"
                                    ref={this.fileInputRef}
                                    style={{ display: 'none' }}
                                    accept=".pdf,.docx, .doc"
                                    onChange={this.handleFileChange}
                                />
                               
                                {selectedFileName && (
                                    <p className="file-name">
                                        <span style={{ fontWeight: 500 }}>Selected file:</span> {selectedFileName}
                                    </p>
                                )}


                                <div className='btn_sec' onClick={this.handleSubmitResume}>
                                    <a className='upload_btn'>Submit Resume</a>
                                </div>
                            </div>

                        </div>
                    </div>
                )} */}



      {isPopupVisible && (
  <div className="popup-overlay">
    <div className="popup-content">

      {/* HEADER (not scrollable) */}
    <div className="popup-header">
  <h3>Submit Your Details</h3>

  <button
    className="close-button"
    onClick={() => this.setState({ isPopupVisible: false })}
  >
    <img src="/assets/Vector.png" alt="close" />
  </button>
</div>


      {/* SCROLLABLE CONTENT */}
      <div className="popup-scroll">

        {/* FORM */}
        <div className="form-container">
          <div className="form-field">
            <label>Name*</label>
            <input
  type="text"
  placeholder="Enter"
  className="form-input"
  value={this.state.name}
  maxLength={30}
  onChange={(e) => {
    const value = e.target.value.replace(/[^A-Za-z ]/g, "");
    this.setState({ name: value });
    this.validateField("name", value);
  }}
/>
{this.state.errors.name && (
  <small className="error">{this.state.errors.name}</small>
)}

          </div>

          <div className="form-field">
            <label>Phone Number*</label>
           <input
  type="text"
  placeholder="Enter"
  className="form-input"
  value={this.state.phone}
  maxLength={10}
  onChange={(e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    this.setState({ phone: value });
    this.validateField("phone", value);
  }}
/>
{this.state.errors.phone && (
  <small className="error">{this.state.errors.phone}</small>
)}

          </div>

          <div className="form-field">
            <label>Email ID*</label>
           <input
  type="email"
  placeholder="Enter"
  className="form-input"
  value={this.state.email}
  onChange={(e) => {
    this.setState({ email: e.target.value });
    this.validateField("email", e.target.value);
  }}
/>
{this.state.errors.email && (
  <small className="error">{this.state.errors.email}</small>
)}

          </div>

          <div className="form-field">
            <label>Current CTC*</label>
           <input
  type="text"
  placeholder="Enter"
  className="form-input"
  value={this.state.currentCTC}
  maxLength={7}
  onChange={(e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    this.setState({ currentCTC: value });
    this.validateField("currentCTC", value);
  }}
/>
{this.state.errors.currentCTC && (
  <small className="error">{this.state.errors.currentCTC}</small>
)}

          </div>

        <div className="form-field">
  <label>Expected CTC*</label>
  <input
    type="text"
    placeholder="Enter"
    className="form-input"
    value={this.state.expectedCTC}
    maxLength={7}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      this.setState({ expectedCTC: value });
      this.validateField("expectedCTC", value);
    }}
  />
  {this.state.errors.expectedCTC && (
    <small className="error">{this.state.errors.expectedCTC}</small>
  )}
</div>


          <div className="form-field">
            <label>Select Notice Period (in days)*</label>
            <select
              className="form-input"
              value={this.state.noticePeriod}
              onChange={(e) => this.setState({ noticePeriod: e.target.value })}
              style={{
                color: this.state.noticePeriod === "" ? "#A0A0A0" : "#000",
              }}
            >
              <option value="" disabled>Select</option>
              <option value="Fresher">Fresher</option>
              <option value="Immediate Joiner">Immediate Joiner</option>
              <option value="7 Days">7 Days</option>
              <option value="15 Days">15 Days</option>
              <option value="30 Days">30 Days</option>
              <option value="45 Days">45 Days</option>
              <option value="60 Days">60 Days</option>
              <option value="90 Days">90 Days</option>
            </select>
          </div>
        </div>

        {/* RESUME UPLOAD */}
        <div className="upload-container">
          <label className="upload-label">Upload Resume</label>

          <div className="upload-box" onClick={this.handleButtonClick}>
            <div className="upload-icon">
              <img src="/assets/upload-icon.svg" alt="uplod-icon" />
            </div>
            <p>
              <span className="upload-link">Choose file</span> to upload
            </p>
            <small className='upload-txt'>Supported formats: pdf, doc, or docx file</small>
          </div>

          <input
            type="file"
            ref={this.fileInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx"
            onChange={this.handleFileChange}
          />

          {selectedFileName && (
            <p className="file-name">{selectedFileName}</p>
          )}

          <button className="submit-btn" onClick={this.handleSubmitResume}>
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>
)}





        <Footer />
      </div>

    )
  }
}

export default JobDescription

